import React from "react";

import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";

import { Amount, Card, Chip, Info as InfoIcon } from "@ip-widgets";

export default function Info({
  config,
  children,
  isMe,
  ledgersTotal,
  linesTotal,
  loading,
  name,
  number,
}) {
  function createAmount(currency) {
    const item = {
      balance: 0,
      currency,
      outstanding: 0,
    };
    amounts.push(item);
    return item;
  }

  const amounts = [];

  if (ledgersTotal) {
    config.forEach((entity) => {
      let amount = 0;
      Object.values(ledgersTotal[entity.id] || {}).forEach((taxes) => {
        amount += taxes[entity.currency] || 0;
      });

      if (amount) {
        const item =
          amounts.find((item) => item.currency === entity.currency) ||
          createAmount(entity.currency);
        item.balance += amount;
      }
    });
  }

  if (linesTotal) {
    Object.values(linesTotal).forEach((currencies) => {
      Object.entries(currencies).forEach(([currency, amount]) => {
        const item =
          amounts.find((item) => item.currency === currency) ||
          createAmount(currency);
        item.outstanding += amount;
      });
    });
  }

  if (amounts.length) {
    amounts.sort((a, b) => (a.currency > b.currency ? 1 : -1));
  } else {
    createAmount(" ");
  }

  const balanceTooltip = `Funds can only be held in the home currencies of the iglu entity with which ${
    isMe ? "you hold" : "the IE holds"
  } an employment contract`;

  const title = (
    <React.Fragment>
      <Chip.EmployeeNumber isMe={isMe} value={number} />
      <Box component="span" marginLeft={1}>
        {name}
      </Box>
    </React.Fragment>
  );

  return (
    <Card title={title}>
      <Card.Body loading={loading}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell />
              <TableCell align="right">
                Balance
                <InfoIcon tooltip={balanceTooltip} />
              </TableCell>
              <TableCell align="right">
                Outstanding
                <InfoIcon tooltip="Amounts are subject to fees and exchange rates" />
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {amounts.map((item, key) => (
              <TableRow key={key}>
                <TableCell>{item.currency}</TableCell>
                <TableCell align="right">
                  <Amount value={item.balance} />
                </TableCell>
                <TableCell align="right">
                  <Amount value={item.outstanding} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        {children}
      </Card.Body>
    </Card>
  );
}
